<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'
import { bookParams } from '@/composables/tracks/bookParameters'
import { superstoryTrack } from '@/track'

const props = defineProps<{
  cornerMarkText?: string | null
  feeds: any[]
  feedShowName: string
  feedId: string
  feedsColumnType: string | number
  feedFetching: boolean
  feedEnding: boolean
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  titleClass?: string
  rowClass?: string
  coverClass?: string
  bookTitleClass?: string
  introClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
}>()

// 可选样式：不传时完全等价于改造前的写死类名
const ROW_CLASS_DEFAULT = 'mt-5 flex items-center space-x-15px'
const COVER_CLASS_DEFAULT = 'w-19.2vw rounded-8px'
const BOOK_TITLE_CLASS_DEFAULT = 'text-15px font-bold line-clamp-1 text-n-text-1'
const INTRO_CLASS_DEFAULT = 'text-13px mt-10px line-clamp-2 break-anywhere text-n-text-3'
</script>

<template>
  <div>
    <ModuleCard
      v-if="feeds.length"
      :column-id="feedId"
      :title-text="feedShowName"
      :show-action="false"
      :card-class="props.cardClass"
      :header-class="props.headerClass"
      :title-class="props.titleClass"
    >
      <div v-for="(item, index) in feeds" :key="item.id">
        <div
          :class="rowClass || ROW_CLASS_DEFAULT" @click="superstoryTrack('column_ck', bookParams({
            ...item,
            pos: index + 1,
            module_id: feedId,
            module_name: feedShowName,
          })); gotoBook(item.id, item.firstChapter?.id)"
        >
          <BizBookCover
            :id="uuid()"
            :corner-mark-text="cornerMarkText"
            :src="item.contentCoverUrl || ''"
            :extra="{
              module_name: feedShowName,
              module_id: feedId,
              module_type: feedsColumnType,
              author: item.authorInfo.author,
              ...item,
              pos: index + 1,
            }"
            :class="coverClass || COVER_CLASS_DEFAULT"
          />

          <div class="flex-1 overflow-hidden">
            <p :class="bookTitleClass || BOOK_TITLE_CLASS_DEFAULT">
              {{ item.contentName?.replace(/&nbsp;/g, ' ') ?? '' }}
            </p>
            <p :class="introClass || INTRO_CLASS_DEFAULT">
              {{ item.introduce }}
            </p>
            <BizShowTags v-if="item.tagList && item.tagList.length" :tags="item.tagList" class="mt-10px" />
          </div>
        </div>
      </div>
    </ModuleCard>
    <div v-if="feedEnding" class="py-15px text-13px text-center text-n-text-3">
      {{ config.texts.noMore }}
    </div>
    <div v-else-if="feedFetching" class="py-15px flex items-center justify-center space-x-4 text-13px text-n-text-3">
      <div class="animate-spin">
        <i-icon-park-outline-loading />
      </div>
      <p>{{ config.texts.loading }}</p>
    </div>
  </div>
</template>
